import {
  allowedCorsOrigin,
  createContactProxyHandlers,
  enforceRateLimit,
  resetContactProxyRateLimitState,
} from "@server/contactProxy"
import { serverRouteConfig } from "@server/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

const contactProxyHandlers = createContactProxyHandlers()

export { allowedCorsOrigin, enforceRateLimit }
export const resetRateLimitState = resetContactProxyRateLimitState

export const Route = createFileRoute("/api/")(
  serverRouteConfig({
    server: {
      handlers: contactProxyHandlers,
    },
  })
)
